'use es6';

export const LOCATION_CHANGE = 'LOCATION_CHANGE';
const initialState = {
  locationBeforeTransitions: {}
};
export function routerReducer(state = initialState, {
  type,
  payload
} = {}) {
  if (type === LOCATION_CHANGE) {
    return Object.assign({}, state, {
      locationBeforeTransitions: payload
    });
  }

  return state;
}